import React from "react";
import Card from "react-bootstrap/Card";
import { BsLink } from "react-icons/bs";
import {
    slideInRight,
    bounceIn,
    slideInLeft,
    slideInUp,
    slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";


function BlogCard(props) {
    const styles = {
        slideInLeft: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInLeft, "bounce"),
        },
        slideInUp: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInUp, "bounce"),
        },
        slideInRight: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInRight, "bounce"),
        },
        bounceIn: {
            animation: "x 3s",
            animationName: Radium.keyframes(bounceIn, "bounce"),
        },
        slideInDown: {
            animation: "x 3s",
            animationName: Radium.keyframes(slideInDown, "bounce"),
        },
    };
    return (
        <StyleRoot>

            <a
                className="blog-link"
                href={props.link}
                target="_blank"
                rel="noreferrer"
                style={{ fontSize: "1.2em" }}
            >
                <Card className="blog-card-view">
                    <div style={styles.slideInLeft}>
                        <Card.Img variant="top" style={{ height: '140px' }} src={props.imgPath} className="blog-img" />

                    </div>
                    <div style={styles.slideInRight}>
                        <Card.Footer>
                            <BsLink />
                            &nbsp;
                            {props.title}
                            <p style={{ marginBlockEnd: "0em" }}>{props.site}</p>
                        </Card.Footer>

                    </div>

                </Card>
            </a>
        </StyleRoot>

    );
}

export default BlogCard;
